var ol = require('../dist/ol-debug');
ol.pointer.PointerEventHandler.prototype.eventHandler_ = function(inEvent) {
    var type = inEvent.type;
    var handler = this.eventMap_[type];
    if (type == 'pointerdown') {
        this.startPoint = {
            x: inEvent.offsetX,
            y: inEvent.offsetY
        };
    }
    if (handler) {
        if (type == 'pointermove') {
            if (this.startPoint) {
                if (Math.abs(this.startPoint.x - inEvent.offsetX) + Math.abs(this.startPoint.y - inEvent.offsetY) < 3) {
                    return;
                }
            }
        }
        handler(inEvent);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/touchfix.js
// module id = 29
// module chunks = 0